import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";

export const cadastrarAgrupamentoContaBanco = createAsyncThunk("/AgrupamentoContaBanco/CadastrarAgrupamentoContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/AgrupamentoContaBanco/CadastrarAgrupamentoContaBanco", payload.value);
    toastSucess("Conta bancária associada ao grupo com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarAgrupamentoContaBanco({ idGrupoContaBanco: payload.value.idGrupoContaBanco }));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarAgrupamentoContaBanco = createAsyncThunk("/AgrupamentoContaBanco/BuscarAgrupamentoContaBanco", async (args: { idGrupoContaBanco?: number | null; idContaBanco?: number | null }) => {
  try {
    const data = await api.get("/AgrupamentoContaBanco/BuscarAgrupamentoContaBanco", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const deletarAgrupamentoContaBanco = createAsyncThunk("/AgrupamentoContaBanco/DeletarAgrupamentoContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/AgrupamentoContaBanco/DeletarAgrupamentoContaBanco", { params: { id: payload.value } });
    toastSucess("Associação removida com sucesso");
    dispatch(setLoading(false));

    if (payload.idGrupoContaBanco) {
      dispatch(buscarAgrupamentoContaBanco({ idGrupoContaBanco: payload.idGrupoContaBanco }));
    }
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const sincronizarAgrupamentoContaBanco = createAsyncThunk(
  "/AgrupamentoContaBanco/SincronizarAgrupamentoContaBanco",
  async (payload: { idGrupoContaBanco: number; listaIdContaBanco: number[] }, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      await api.post("/AgrupamentoContaBanco/SincronizarAgrupamentoContaBanco", payload);
      toastSucess("Contas bancárias sincronizadas com sucesso");
      dispatch(setLoading(false));

      dispatch(buscarAgrupamentoContaBanco({ idGrupoContaBanco: payload.idGrupoContaBanco }));
    } catch (error: any) {
      dispatch(setLoading(false));
      toastError(error.response.data.Message);
    }
  }
);
